// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import 'babel-polyfill'
import ElementUI from 'element-ui'
import Axios from 'axios'
import NProgress from 'nprogress'
import uploader from 'vue-simple-uploader'

import App from './App'
import store from './store'
import router from './router'
import 'element-ui/lib/theme-chalk/index.css'
import '@/assets/font-awesome-4.7.0/css/font-awesome.min.css'
import '@/assets/iconfont/iconfont.css'
import '@/assets/css/main.css'
import '@/assets/css/scrollbar.css'
import '@/assets/css/reset.css'
import 'nprogress/nprogress.css'
import 'animate.css'
import '@/styles/element-ui.less'
import '@/styles/transtions.less'
// 引用日期插件
import 'vue-event-calendar/dist/style.css'
import vueEventCalendar from 'vue-event-calendar'

import DropdownPlugin from './m/dropdown'
import NavbarPlugin from './m/navbar'
import ContextMenuPlugin from './m/context-menu'
import MLoading from '@/m/loading'
import MBackTop from '@/m/back-top'

// 引用全局资源
import '@/api/filters.js'
import '@/api/common.js'

import Qs from 'qs'

Vue.use(ElementUI)
Vue.use(uploader)
Vue.use(DropdownPlugin)
Vue.use(NavbarPlugin)
Vue.use(ContextMenuPlugin)
Vue.use(MLoading)
Vue.use(MBackTop)
Vue.use(vueEventCalendar, {locale: 'zh'})

var whiteList = ['home', 'login']
router.beforeEach((to, from, next) => {
  if(from.path.indexOf('todoDetail') === -1 && to.path.indexOf('todoDetail') === -1){
    sessionStorage.removeItem("page")
    sessionStorage.removeItem("paginationData")
  }

  var token = sessionStorage.getItem('token')
  if (!token && whiteList.indexOf(to.name) === -1) {
    app && app.$message.warning('未授权，请登陆授权后继续')
    NProgress.done()
    return next({name: 'login'})
  }
  return next()
})

router.afterEach(transition => {
  setTimeout(() => {
    NProgress.done()
  })
})

window.APP_INFO = process.env.APP_INFO
// 全局的 axios 默认值全局的 axios 默认值

// eslint-disable-next-line eqeqeq
Axios.defaults.baseURL = process.env.NODE_ENV == 'development' ? '/api' : ''
// Axios.defaults.headers.post['content-type'] = 'application/x-www-form-urlencoded';
// status < 500 不会抛错误
Axios.defaults.validateStatus = status => {
  return status < 500
}
// 设置请求token
Axios.interceptors.request.use(config => {
  var token = sessionStorage.getItem('token')
  if (token) {
    config.headers['Authorization'] = token
  } else {
    config.headers['Authorization'] = ''
  }

  // config.headers['content-type'] = 'multipart/form-data'
  // config.headers['processData'] = false
  // console.log(config)
  return config
})
// Axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';
Axios.defaults.transformRequest = [function(data) {
  return Qs.stringify(data, {allowDots: true })
}]
// 接口错误拦截
Axios.interceptors.response.use(res => {
  if (res.status === 401) {
    app && app.$message({
      type: 'warning',
      message: res.data.msg
    })
    sessionStorage.removeItem('token')
    sessionStorage.removeItem('user')
    router.push({name: 'login'})
  } else if (res.status >= 400 && res.status < 500  && typeof(res.data) === 'string') {
    app && app.$message({
      type: 'warning',
      message: res.data
    })
    return Promise.reject(res)
  } else {
    return res.data
  }
}, err => {
  app.$notify.error({
    title: '服务错误',
    message: err.response.data.msg
  })
  return Promise.reject(err)
})


Vue.prototype.$http = Axios
Vue.http = Axios

Vue.config.productionTip = false

/* eslint-disable no-new */
var app = new Vue({
  el: '#app',
  store,
  router,
  template: '<App/>',
  components: { App }
})

window.app = app



// WEBPACK FOOTER //
// ./src/main.js